import { Box, Button, Modal, Typography } from "@mui/material";
import { themePalette } from "../../config/theme.config";

const ConfirmationModal = ({ isOpen, message, onConfirm, onClose } : {isOpen: boolean, message: string, onConfirm: any, onClose: any}) => {
    return (
      <Modal
        open={isOpen}
        onClose={onClose}
        aria-labelledby="confirmation-modal-title"
        aria-describedby="confirmation-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          {/* <Typography
            id="confirmation-modal-title"
            variant="h6"
            component="h2"
            gutterBottom
          >
            Confirmación
          </Typography> */}
          <Typography
            id="confirmation-modal-description"
            variant="body1"
            sx={{ mb: 3 }}
          >
            {message}
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
            <Button variant="outlined" style={{
                            color: `${themePalette.BONDIBLUE}`, // Light blue text
                            borderColor: `${themePalette.BONDIBLUE}`, // Light blue border
                            textTransform: 'none', // Prevent uppercase transformation
                            borderRadius: '50px', // Circular borders
                          }} onClick={onClose}>
              No
            </Button>
            <Button variant="contained"  sx={
                        { ml: 2, 
                          backgroundColor: '#0A2C6B', '&:hover': 
                          {
                            backgroundColor: '#082354'  // Darker shade for hover effect
                          },
                        }
                      } onClick={onConfirm}>
              Sí
            </Button>
          </Box>
        </Box>
      </Modal>
    );
  };
  
  export default ConfirmationModal;